import React from 'react';
import { TimesheetRowDto } from 'src/api/FiretrolApiClient';
import { useEffectiveRatePreview } from 'src/hooks/useEffectiveRatePreview';
import { EffectiveRateCell } from 'src/app/timesheets/EffectiveRateCell';

export interface ITimesheetRowRateProps {
  row: TimesheetRowDto;
  userId: number;
  jobId: number;
  isComplete?: boolean;
}

export const TimesheetRowRate: React.FC<ITimesheetRowRateProps> = ({
  row,
  userId,
  jobId,
  isComplete = false,
}) => {
  const {
    effectiveRate: previewRate,
    instructions: previewInstructions,
    loading,
    error,
  } = useEffectiveRatePreview({
    userId,
    jobId,
    payCodeId: isComplete ? '' : row.payCodeId || '',
    wbsAccountId: row.wbsAccountId || undefined,
  });

  // Actualized rows already carry the persisted rate and the server-built breakdown
  // instructions on the DTO — no client-side reconstruction needed.
  const effectiveRate = isComplete ? row.effectiveRate : previewRate;
  const instructions = isComplete
    ? row.breakdownInstructions
    : previewInstructions;
  const isLoading = isComplete ? false : loading;
  const hasError = isComplete ? null : error;

  return (
    <EffectiveRateCell
      effectiveRate={effectiveRate}
      instructions={instructions}
      loading={isLoading}
      error={hasError}
      isActualized={isComplete && !!instructions}
      payCodeColor={isComplete ? row.payCodeColor : row.payCode?.color}
    />
  );
};
